import React, { useContext } from 'react';
import { IterationContext, IterationContextType } from '../../contexts/IterationContext';
import IterationSidebar from './IterationSidebar';
import IterationTabs from './IterationTabs';
import IterationContent from './IterationContent';

const IterationComponent: React.FC = () => {
    const {
        activeIterationId,
        currentIteration,
        activeIterationTab,
        iterationPayload,
        addIteration,
        removeIteration,
        setActiveIterationId,
        setActiveIterationTab,
        reorderIterations,
        copyIteration,
        renameIteration,
        setIterationPayload
    } = useContext<IterationContextType>(IterationContext);

    return (
        <div className="tw-bg-white tw-mt-4 tw-border tw-border-zinc-300 tw-shadow-sm" data-testid="iteration-component">
            <div className="tw-flex">
                {/* Left sidebar with iterations */}
                <IterationSidebar
                    iterations={iterationPayload?.iterations || [] as Iteration[]}
                    activeIteration={activeIterationId}
                    setActiveIteration={setActiveIterationId}
                    addIteration={addIteration}
                    removeIteration={removeIteration}
                    reorderIterations={reorderIterations}
                    copyIteration={copyIteration}
                    renameIteration={renameIteration}
                />

                {/* Right content area */}
                <div className="tw-flex-1">
                    {activeIterationId && currentIteration ? (
                        <div>
                            {/* Tabs */}
                            <IterationTabs
                                activeTab={activeIterationTab}
                                setActiveTab={setActiveIterationTab}
                            />

                            {/* Tab content */}
                            <IterationContent
                                activeTab={activeIterationTab}
                                iterationId={activeIterationId}
                                iterationName={currentIteration.name}
                                iterationPayload={iterationPayload}
                                setIterationPayload={setIterationPayload}
                            />
                        </div>
                    ) : (
                        <div className="tw-flex tw-items-center tw-justify-center tw-h-48 tw-text-gray-500">
                            No iteration selected
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default IterationComponent;